import { FC, useEffect, useState } from 'react'
import { useDateTime } from '../../../shared/useDateTime'
import { TimeZoneAndLocale } from '../../../types.custom'
import { TimePicker } from 'antd'
import { Moment } from 'moment-timezone'
import { useTranslation } from 'react-i18next'

export interface TimePickerProps {
  inputDate: string
  onTimeChanged: (outputDate: string) => void
  timeZoneAndLocale: TimeZoneAndLocale
  timeFormat: 'HH:mm'
  disabled?: boolean
  disabledDate?: (current: Moment) => boolean
  showTime?: boolean
  minuteStep?: number
  hideDisabledOptions?: boolean
}

const PerTimePicker: FC<TimePickerProps> = ({
  inputDate,
  timeFormat,
  timeZoneAndLocale,
  onTimeChanged,
  minuteStep,
  hideDisabledOptions,
}) => {
  const { utcDateStringToMoment, momentToUtcDateString, localesWith12HourTimeFormat } = useDateTime(timeZoneAndLocale)
  const [t] = useTranslation()
  //
  // NOTE:
  //  We get dates as utc-strings and emit dates as utc-strings!
  //  Only internally we convert them to moment-timezone objects! Never pass moment to the outside!
  //
  //  +-------------------+       +----------------+      +------------+       +----------------+       +--------------------+
  //  | inputDate: string | ----> | moment: Moment | ---> | TimePicker | ----> | moment: Moment | ----> | outputDate: string |
  //  +-------------------+       +----------------+      +------------+       +----------------+       +--------------------+
  //
  const [inputTimeAsMoment, setInputTimeAsMoment] = useState<Moment | undefined>(utcDateStringToMoment(inputDate))
  useEffect(() => {
    setInputTimeAsMoment(utcDateStringToMoment(inputDate))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputDate])

  const handleTimePickerChange = (time) => {
    const newDate = momentToUtcDateString(time)
    if (!!time) {
      setInputTimeAsMoment(time)
    }
    if (time && newDate) {
      // ONLY EMIT VALID DATES! => Prevent clear
      onTimeChanged(newDate)
      setInputTimeAsMoment(time)
    }
  }

  const locale1 = { placeholder: timeZoneAndLocale.locale }
  return (
    <TimePicker
      value={inputTimeAsMoment}
      format={localesWith12HourTimeFormat.includes(timeZoneAndLocale.locale) ? 'h:mm a' : timeFormat}
      onChange={handleTimePickerChange}
      locale={locale1}
      placeholder={t('timePicker.placeholder')}
      minuteStep={minuteStep}
      hideDisabledOptions={hideDisabledOptions}
      allowClear={false}
      use12Hours={localesWith12HourTimeFormat.includes(timeZoneAndLocale.locale)}
    />
  )
}

export default PerTimePicker
